import React from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from '../layouts/BoxedContainer';

export default function DiningAndShopping({ data }) {
  const { title, text, dswDiningAndShoppingList } = data;
  return (
    <section className={`bg-bg-1 
    ${title.includes("sponsor") 
    ? 'clip-right-top pb-[80px] lg:pb-[190px] lg:pt-[190px] pt-[80px] lg:mt-[110px] mt-[50px]' 
    : 'lg:mt-[140px] mt-[70px] lg:pt-[95px] pt-[60px]'}`}>
      <BoxedContainer className="regular">
        <div className="flex flex-col lg:gap-y-[58px] gap-y-[30px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[30px] gap-y-[10px] lg:max-w-[685px]">
              {isEmpty(title) || (
            <h3
              className="text-primary uppercase lg:text-2xl text-[35px]
            leading-10 font-roboto-condensed-bold">
              {title}
            </h3>
              )}
              {isEmpty(text) || (
            <p className="lg:text-base text-[15px] leading-6 text-primary font-roboto-regular">
              {text}
            </p>
              )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="flex flex-wrap lg:gap-x-[30px] md:gap-x-[15px] lg:gap-y-[30px]
            gap-y-[15px]">
            {isEmpty(dswDiningAndShoppingList) ||
              dswDiningAndShoppingList.map((item, index) => (
                <div className="md:w-[calc(51.25%-30px)] bg-white" key={index}>
                  <div className="md:h-[300px]">
                    {item.content.image && (
                      <LazyLoadImage
                        src={item.content.image.url}
                        alt={item.content.title}
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                  <div
                    className="flex flex-col lg:gap-y-[37px] gap-y-[15px] bg-white md:min-h-[355px]
                    min-h-[270px] md:pt-[43px] pt-[25px] lg:px-10 px-5 md:pb-[60px] pb-[30px]">
                    <h3
                      className="text-black font-roboto-condensed-bold md:text-[23px] text-[20px]
                    leading-[26px] uppercase">
                      {item.content.title}
                    </h3>
                    <p
                      className="lg:text-base text-[15px] leading-7 text-black
                    font-roboto-regular"
                      dangerouslySetInnerHTML={{
                        __html: item.content.text.replace(/\n/g, '<br>'),
                      }}
                    />
                    {/* <p
                      className="lg:text-base text-[15px] leading-7 text-black
                    font-roboto-regular">
                      {item.openingTime}
                    </p> */}
                  </div>
                </div>
              ))}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}